<template>
    <div>
        <create-update :event-id="event.id" @created="updateCreated"></create-update>

        <div class="editable-updates-wrapper">
            <div v-for="update in form" v-bind:key="update.id">
                <editable-update
                    :update="update"
                    @changed="updateChanged"
                    @deleted="updateDeleted">
                </editable-update>
            </div>
        </div>
    </div>
</template>

<script>
    import EditableUpdate from '@/components/EditableUpdate.vue';
    import CreateUpdate from '@/components/CreateUpdate.vue';
    import updateRepository from "@/repository/updates";
    import { VueEditor } from "vue2-editor";

    export default {
        props: ['updates', 'event'],

        components: {
            EditableUpdate,
            CreateUpdate,
            VueEditor
        },

        data() {
            return {
                form: [],
                errors: {},
            }
        },

        mounted() {
            this.form = [ ...this.updates ];
        },

        methods: {
            updateCreated(update) {
                updateRepository.store(update)
                    .then(response => {
                        let new_update = response.data;
                        this.form.push(new_update);
                        
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Update created',
                            text: 'Update successfully created.'
                        });
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            },

            updateChanged(update) {
                updateRepository.update(update)
                    .then(response => {
                        let updated_update = response.data;
                        let idx = this.form.findIndex(d => d.id === updated_update.id);
                        let update = this.form[idx];

                        this.form.splice(idx, 1, updated_update);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Update updated',
                            text: 'Update successfully updated.'
                        });
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            },

            updateDeleted(update) {
                updateRepository.destroy(update.id)
                    .then(response => {
                        let idx = this.form.findIndex(d => d.id === update.id);
                        this.form.splice(idx, 1);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Update deleted',
                            text: 'Update successfully deleted.'
                        });
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>